import React from 'react'
import { TitreGridView } from './titre-grid.view'

interface IProps {
	titres: any
}

export const TitreGridContainer = ({ titres }: IProps) => {
	const localTitres = [
		{
			id: 2776,
			acf: {
				titre: 'Croix du Nord',
				logo:
					'https://www.espacephr.fr/wp-content/uploads/2020/08/Croix-du-Nord.jpg',
				logo_carte: false,
				info_hebdo: '',
				carte_id: 'Auvergne-Rhône-Alpes',
				departement: '01 - Ain',
				url: 'https://actu.fr/croix-du-nord/dernieres-actus',
				directeur_publication: 'Francis Gaunand',
				adresse_de_la_redaction: ' 33 rue Négrier – 59009 Lille cedex',
				pub_day: '',
				sort: '',
				pub: '',
			},
		},
		{
			id: 2770,
			acf: {
				titre: 'Bulletin d’Espalion',
				logo:
					'https://www.espacephr.fr/wp-content/uploads/2020/08/bulletin-despalion.jpg',
				logo_carte: false,
				info_hebdo: '',
				carte_id: 'Auvergne-Rhône-Alpes',
				departement: '01 - Ain',
				url: 'https://www.bulletindespalion.fr/',
				directeur_publication: '',
				adresse_de_la_redaction: '6 Rue Antoine Fanguin 12500 ESPALION',
				pub_day: '',
				sort: '',
				pub: '',
			},
		},
		{
			id: 2768,
			acf: {
				titre: 'Courrier Français - Édition des Landes',
				logo:
					'https://www.espacephr.fr/wp-content/uploads/2020/08/logo-courrier-francais.jpg',
				logo_carte: false,
				info_hebdo: '',
				carte_id: 'Auvergne-Rhône-Alpes',
				departement: '01 - Ain',
				url: 'https://www.espacephr.fr/hebdos/courrier-francais/',
				directeur_publication: '',
				adresse_de_la_redaction: 'Mont-de-Marsan',
				pub_day: '',
				sort: '',
				pub: '',
			},
		},
		{
			id: 929,
			acf: {
				titre: 'Echo d’Ile de France',
				logo:
					'https://www.espacephr.fr/wp-content/uploads/2020/08/Echo-d’Ile-de-France.png',
				carte_id: 'Auvergne-Rhône-Alpes',
				departement: '01 - Ain',
				url: 'https://www.echoidf.fr/',
				directeur_publication: 'Jean-Pierre de Kerraoul',
				adresse_de_la_redaction:
					'95 avenue de la Résistance BP 31 93341 LE RAINCY CEDEX',
				logo_carte: false,
				info_hebdo: '',
				pub_day: '',
				sort: '',
				pub: '',
			},
		},
	]
	return <TitreGridView titres={titres} />
}
